import styled from "@emotion/styled";
import { FC, useCallback, useMemo } from "react";
import { MdsIconKind } from "@/design-system/components/icon";
import { windowModule } from "@/modules/window";
import { MDSButton, MDSButtonIcon } from "@/mds";

interface FloatingTextMessageMediaButtonProps {
  contentType: string;
  publicUrl: string;
}

export const FloatingTextMessageMediaButton: FC<FloatingTextMessageMediaButtonProps> = ({
  contentType,
  publicUrl,
}) => {
  const buttonInfo: {
    iconKind: MdsIconKind;
    label: string;
  } = useMemo(() => {
    if (contentType.startsWith("image/")) {
      return {
        iconKind: MdsIconKind.Image,
        label: "Image",
      };
    }

    if (contentType.startsWith("video/")) {
      return {
        iconKind: MdsIconKind.Video,
        label: "Video",
      };
    }

    if (contentType.startsWith("audio/")) {
      return {
        iconKind: MdsIconKind.WaveformLines,
        label: "Audio",
      };
    }

    if (contentType.startsWith("application/pdf")) {
      return {
        iconKind: MdsIconKind.Pdf,
        label: "PDF",
      };
    }

    return {
      iconKind: MdsIconKind.File,
      label: "File",
    };
  }, [contentType]);

  const onClick = useCallback(() => {
    windowModule.openInNewTab({ url: new URL(publicUrl) });
  }, [publicUrl]);

  return (
    <TextMessageMediaButton onClick={onClick}>
      <TextMessageMediaButtonIcon kind={buttonInfo.iconKind} />
      {buttonInfo.label}
    </TextMessageMediaButton>
  );
};

export const TextMessageMediaButton = styled(MDSButton)(
  () => `
  text-align: left;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: fit-content;
`
);

const TextMessageMediaButtonIcon = styled(MDSButtonIcon)`
  margin-right: ${({ theme }) => theme.spacing.xs};
`;
